module.exports = __webpack_public_path__ + "img/arch-desktop.662d99ae.jpg";